import React, {
  Component, useState,useEffect
} from 'react';
import Menu from "../Menu";
import Header from '../Header';
import { Select } from 'antd';
import { DatePicker, Space } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { doGetVendorList, SaveVendorContractMappingInfo, VendorList,doGetVendorContractList, getAssetDetails } from './actions/vendorService';
import { Switch } from 'antd';
import { Link } from 'react-router-dom'
import Cookie from 'js-cookie';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import Spinner from '../../UIComponents/Spinner/Spinner';
import LZString from 'lz-string';
import dayjs from 'dayjs';
const { Option } = Select;

const VendorContractMappingEdit = (props) => {
  const {Editdata}=props;
  // console.log(Editdata,'editData')
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData)
  const userID = user['userId'];

  const vendorContractList = useSelector(state => state?.vendorList?.VendorContractDetails)
  const [isSubmit, setIsSubmit] = useState(false)
  const [Vendor, setVendor] = useState('')
  const [storeImage, setStoreImage] = useState("");
  const [storeImageName, setStoreImageName] = useState("");
  const [mobileNumber, setMobileNumber] =useState(Editdata.mobile_number1); 
  const [email, setEmail] = useState(Editdata.email_address1);
  const apiInfo = useSelector(state => state?.vendorList)
  const existingContracts = useSelector(state => state?.vendorList?.VendorContractDetails?.ExistingContracts)
  const assetDetails = useSelector(state => state?.vendorList?.AssetDetails)
  const [assetListData, setAssetListData] = useState([])
  const [mainIds,setMainIds] = useState([])
  const [subIds,setSubIds] = useState([])
  const [subCategory, setSubCategory] = useState([]);
  const [assetIds,setAssetIds] = useState([])
  const [currentUserAssets, setCurrentUserAssets] = useState([])
  const [newExistingContracts,setNewExistingContracts] = useState([])
  const [assetDetailsInfo, setAssetDetailsInfo] = useState([])
  // console.log(vendorContractList)
  const dispatch = useDispatch()
  const [form, setState] = useState({
    fed_id: userID,
    vendorcontractmapid: Editdata?.id,
    vendorid:  Editdata?.vendor_row_id,
    maincategoryid: mainIds,
    subcategoryid: subIds,
    assetid:assetIds,
    contractstartdate: Editdata?.contract_start_date,
    contractenddate: Editdata?.contract_end_date,
    vendorcontractmapbase64:'',
    contract_file_name: '',
    storeid: Editdata?.store_id,
    vendorstatus: Editdata?.vendor_status,

  })
  const _doNavToVendors = () => {
    this.props.navigate("/Vendors");
  };
  const _doSelectVendor = (event) => {

    setVendor(event.target.value)
  }
  useEffect(() => {
    selectVendor( Editdata?.vendor_id)
  }, [])
  useEffect(()=>{
    let main_ids=[]
    let mainids = Editdata?.main_catagory_id?.split(',');
    console.log(mainids,'mainids')
    for(let i=0;i<mainids?.length;i++){
      main_ids.push(Number(mainids[i].trim()))
    }
    
    let sub_ids = [];
    let subids = Editdata?.sub_catagory_id?.split(',');
    console.log(subids,'subIds');
    for(let i=0;i<subids?.length;i++){
      sub_ids.push(Number(subids[i].trim()))
    }
    let data = []
    let assetids = Editdata?.asset_id?.split(',')
    for(let i=0;i<assetids?.length;i++){
      if(typeof assetids[i] === 'string'){
        data.push(Number(assetids[i].trim()))
      }
      else{
        data.push(assetids[i])
      }
    }
    // console.log(sub_ids,'sub_ids')
    // console.log(data,'asset_ids')
    setMainIds(main_ids)
    setSubIds(sub_ids);
    setAssetIds(data);
    handleSubCategoryData(main_ids)
    // AssetHandler(sub_ids)
    let currentUserAssetInfo = getAssetListInfo(data)
    setCurrentUserAssets(currentUserAssetInfo);
    let newExistingContractsInfo = getExistingContractsInfo(data)
    setNewExistingContracts(newExistingContractsInfo)
    let payload = {
      storeId: Editdata?.store_id,
      vendorId: Editdata?.vendor_row_id,
      subcategoryId : sub_ids.toString()
    }
    dispatch(getAssetDetails(payload))
  },[Editdata])
  useEffect(()=>{
    if(assetDetails.length>0){
      setAssetDetailsInfo(assetDetails)
      const selectedAssetIds = Editdata?.asset_id?.split(',').map(id => id.trim());

      // Validate and filter selectedAssetIds to ensure they are valid numbers or IDs
      const validSelectedAssetIds = selectedAssetIds.filter(id => !isNaN(id));

      // Filter assetDetails based on validSelectedAssetIds
      const filteredAssetDetails = assetDetails.filter(asset => validSelectedAssetIds.includes(asset.id.toString()));

      // Map the filtered asset details to extract their IDs
      let assetidsInfo = filteredAssetDetails.map(asset => asset.id);
      console.log(assetidsInfo,'assetidsInfo')
      setAssetIds(assetidsInfo)
    }else if(assetDetails.length==0){
      setAssetDetailsInfo([])
    }
  },[assetDetails,Editdata])

  const getAssetListInfo = (assetidsexisting) =>{
    let asset=[]
    for(let i= 0;i<assetidsexisting.length;i++){
      var fetcheddata = vendorContractList.AssetList.filter(ele =>(ele.store_id == form.storeid && ele.asset_id ==assetidsexisting[i])).map(data=>asset.push(data))
    }
    return asset;
  }
  const getExistingContractsInfo = (assetidsexisting)=>{
    let filtExt = existingContracts.filter(ele=>  ele.store_id == form.storeid).map(ele=>ele.string_agg)
    if(filtExt.length>0){
      filtExt = Array.from(filtExt[0]?.split(','),Number)
    }
    let toDelete = new Set(assetidsexisting);
    const newExistingContractsInfo = filtExt.filter(obj=> !toDelete.has(obj))
    // console.log(newExistingContractsInfo,'newExistingContractsInfo');
    return newExistingContractsInfo;

  }

  const selectVendor = (value) => {
    let filteredData = vendorContractList?.VendorsDropDown.filter(ele => ele.vendor_id == value)
    // console.log(value , "value")
    // console.log(filteredData , "filterData")
    // setAddForm({ ...addForm, vendor_company_name: value })
    // setVendorInfo(filteredData[0]);
    setMobileNumber(filteredData[0]?.mobile_number1)
    setEmail(filteredData[0]?.email_address1)
    // setState({...form, mobilenumber:filteredData[0].mobile_number1, email:filteredData[0].email_address1 })

  }

  // const handleAsset = (value) =>{
  //   var filtExt = existingContracts.filter(ele=>  ele.store_id == form.storeid).map(ele=>ele.string_agg)
  //   if(filtExt.length>0){
  //     filtExt = Array.from(filtExt[0]?.split(','),Number)
  //   }
  //   let asset = []
  //   for(let i= 0;i<value.length;i++){
  //     var fetcheddata = vendorContractList.AssetList.filter(ele =>(ele.store_id == form.storeid&&ele.sub_category_name==value[i]?.trim())).map(data=>asset.push(data))
  //   }
  //   var toDelete = new Set(filtExt);
  //   const newArray = asset.filter(obj=> !toDelete.has(obj.asset_id))
  //    setAssetListData(newArray);
  // }
  const setSelectedStoreFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setStoreImageName(file.name);
      let encoded = setStoreImage(reader.result.toString().replace(/^data:(.*,)?/, ''))
    }
    reader.onerror = error => console.log(error)
  }
  const doSubmit = () => {
    setIsSubmit(true);
    if (form.vendorid == '') return;
    else if (mainIds == '') return;
    else if (subIds == '') return;
    else if (assetIds == '') return;
    else if (form.contractstartdate == '') return;
    else if (form.contractenddate == '') return;
    else if (storeImage == '') return;
    else if (form.storeid == '') return;
    form.maincategoryid = mainIds;
    form.subcategoryid = subIds;
    form.assetid = assetIds
    form.contract_file_name = storeImageName;
    form.vendorcontractmapbase64 = storeImage;
    form.vendorid ? form.vendorstatus = 1 : form.vendorstatus = 0
    console.log(form,'form')
    dispatch(SaveVendorContractMappingInfo(form))
  }
  const handleSubCategoryData = (value) =>{
    var sub= []
    // console.log(value,'handleSubCategoryData');
    for(let i=0; i<value.length;i++){
      var dat = vendorContractList?.SubCategory?.filter(ele => (ele.maintenance_maincategory_id == value[i]) && (ele.store_id == Editdata?.store_id)).map(data=>sub.push(data))
    }
    setSubCategory(sub)
  }
  const AssetHandler = (value)=>{
    // console.log(value,'inside AssetHandler')
    // var filtExt = newExistingContracts.filter(ele=>  ele.store_id == form.storeid).map(ele=>ele.string_agg)
    // // console.log(filtExt,' before if condition filtExt')
    // if(filtExt.length>0){
    //   filtExt = Array.from(filtExt[0]?.split(','),Number)
    // }
    // // console.log(filtExt,'filtExt')
    // var asset = []
    // for(let i= 0;i<value.length;i++){
    //   var fetcheddata = vendorContractList.AssetList.filter(ele =>(ele.store_id == form.storeid && ele.sub_category_id==value[i])).map(data=>asset.push(data))
    // }
    // console.log(asset,'asset from AssetList filter')
    // var toDelete = new Set(filtExt);
    // console.log(toDelete,'toDelete')
    // const newArray = asset.filter(obj=> !toDelete.has(obj.asset_id))
    //  console.log(newArray,'newArray')
    //  form.assetid=[]
    //  setState({...form, assetid:[]})
    setAssetIds([])
    fetchAssetInfo(value)
    //  setAssetListData(asset)
    //  return asset
  }
  // const dataHandler = () =>{
  //   // setMainIds([]);
  //   // setSubIds([]);
  //   // // setAssetIds([]);
  //   // setSubCategory([])
  //   // setAssetListData([])
  // }
  const clearSubAsset = (value) =>{
    // console.log(value,'mainCategoryIds clearSubAsset')
    // console.log(subIds,'subIds')
    var sub= []
    for(let i=0; i<value.length;i++){
      var dat = vendorContractList?.SubCategory?.filter(ele => ele.maintenance_maincategory_id == value[i] && ele.store_id == Editdata?.store_id).map(data=>sub.push(data))
    }
    console.log(sub,'subCategory')
    let val=[]
    for(let i=0;i<subIds.length;i++){
      var data = sub.filter(ele=> ele.id == subIds[i] ).map(data=>val.push(data.id))
      // console.log(data,'insnide for lop')
    }
    // console.log(val,'val')
    setSubIds(val)
    var filtExt = newExistingContracts.filter(ele=>  ele.store_id == form.storeid).map(ele=>ele.string_agg)
    // console.log(filtExt,'filtExt before if');
      if(filtExt.length>0){
        // console.log('inside filtExt')
        filtExt = Array.from(filtExt[0]?.split(','),Number)
      }
      // console.log(filtExt,'filtExt')
      var asset = []
      for(let i= 0;i<val.length;i++){
        var fetcheddata = vendorContractList.AssetList.filter(ele =>(ele.store_id == form.storeid&&ele.sub_category_id==val[i])).map(data=>asset.push(data))
      }
      var toDelete = new Set(filtExt);
      // console.log(toDelete,'toDelete')
      const newArray = asset.filter(obj=> !toDelete.has(obj.asset_id))
      // console.log(newArray,'newArray')
      let newAsset = []
      // console.log(assetIds,'assetIds inside clearSubAsset')
      for(let i = 0;i<newArray.length;i++){
        // let newAssetData = assetIds.filter(ele=>ele ==newArray[i]?.asset_id).map(data=>newAsset.push(data))
        let fetchedData = newArray.filter(ele=>ele.asset_id == assetIds[i]).map(data=> newAsset.push(data.asset_id))
        // console.log(fetchedData,'fetchedData inside clearSubAsset')
      }
      // console.log(newAsset,'newAsset inside clearSubAsset')
      setAssetListData(newArray)
      setAssetIds(newAsset)
      fetchAssetInfo(val);
  }
  const clearAsset = (value) =>{
    // setAssetIds([]);
    // const data = AssetHandler(value)
    // console.log(assetIds,'assetIds clearAsset')
    // console.log(data,'assetListData')
    // let newAsset = []
    //   for(let i = 0;i<data.length;i++){
    //     // let newAssetData = assetIds.filter(ele=>ele ==data[i]?.asset_id).map(data=>newAsset.push(data))
    //     let fetchedData = data.filter(ele=>ele.asset_id == assetIds[i]).map(data=> newAsset.push(data.asset_id))

    //   }
      // console.log(newAsset,'newAsset clearAsset')
      // setAssetIds(newAsset)
      // console.log(value,'values')
      // console.log(subIds,'subIdddds')
      if(value.length==0){
        setAssetIds([])
      }
      setAssetDetailsInfo([])

  }
  const fetchAssetInfo = (subidsPayload='') =>{
    if( subIds.length==0)return;
    let payload = {
      storeId: form.storeid,
      vendorId: form.vendorid,
      subcategoryId : subidsPayload ? subidsPayload.toString():subIds.toString()
    }
    dispatch(getAssetDetails(payload))
  }
  return (
    <>
      <Header title={"Edit Vendor Contract Mapping"} />
      <Menu />
      {apiInfo.modalOpen ? (
        <MessageBox
          message={apiInfo.message}
          // signout={false}
          onClose={() => {
            dispatch(doGetVendorContractList(userID))
          }
          }
        />
      ) : null}
      <div className='content-wrapper'>
        {apiInfo.loading ? (
          <Spinner />
        ) : (
          <section className='content top-space'>
            <div className="m-panel">
              <div className="m-panel__body">
                <div className="row m-grid">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor='exampleInput'>Store*</label>
                      <Select className="form-control"
                        onChange={(value) => (setState({ ...form, storeid: value })
                                              // dataHandler()
                                              )}
                        value={form.storeid}
                        disabled
                        showSearch placeholder="-- Please Select --"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLocaleLowerCase()) > 0}
                      >
                        {
                          vendorContractList?.StoresDropdown.map(item => (
                            <Option key={item.store_id} value={item.store_id} >{item.store_name}</Option>
                          ))
                        }
                      </Select>
                      {form.storeid == '' && isSubmit == true ? <span className="text-danger">Please Select Store</span> : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor='exampleInput'>Vendor*</label>
                     
                      <Select className="form-control"
                        // onChange={(value)=>setState({...form, vendorid:value})}
                        disabled
                        showSearch placeholder="-- Please Select --"
                        optionFilterProp="children"
                        onChange={(value) => (selectVendor(value), setState({ ...form, vendorid: value }))}
                        value={form.vendorid}
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLocaleLowerCase()) > 0}
                      >{
                          vendorContractList?.VendorsDropDown.map(item => (
                            <Option key={item.vendor_id} value={item.vendor_row_id}>{item.vendor_company_name}</Option>
                          ))
                        }
                      </Select>
                      {form.vendorid == '' && isSubmit == true ? <span className="text-danger">Please Select Vendor</span> : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group select_h150">
                      <label htmlFor='exampleInput'>Main Category Name*</label>
                      <Select className="form-control"
                        mode='multiple'
                        allowClear={true}
                        onChange={(value) => (setMainIds(value),handleSubCategoryData(value),clearSubAsset(value))}
                        value={mainIds}
                        showSearch placeholder="-- Please Select --"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        }                      
                        >{
                          vendorContractList?.MainCategory.map((item,index) => (
                            <Option key={index} value={item.id} >{item.name}</Option>
                          ))
                        }
                      </Select>
                      {mainIds == '' && isSubmit == true ? <span className="text-danger">Please Select Main Category Name</span> : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group select_h150">
                      <label htmlFor='exampleInput'>Sub Category Name*</label>
                      <Select className="form-control"
                        mode='multiple'
                        allowClear={true}
                        onChange={(value) => (AssetHandler(value),setSubIds(value),clearAsset(value))}
                        value={subIds}
                        showSearch placeholder="-- Please Select --"
                        optionFilterProp="children"
                        onBlur={()=>{
                          return fetchAssetInfo()
                        }}
                        filterOption={(input, option) =>
                          option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                      }
                      >
                        {
                          subCategory.map((item,index) => (
                            <Option key={index} value={item.id}>{item.name}</Option>
                          ))
                        }
                      </Select>
                      {subIds == '' && isSubmit == true ? <span className="text-danger">Please Select Sub Category Name</span> : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group select_h150">
                      <label htmlFor='exampleInput'>Asset*</label>
                      <Select className="form-control"
                        mode='multiple'
                        allowClear={true}
                        onChange={(value) => setAssetIds(value)}
                        showSearch placeholder="-- Please Select --"
                        optionFilterProp="children"
                        value={assetIds}
                        filterOption={(input, option) =>
                          option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                      }
                      >
                        {
                          assetDetailsInfo?.map((item,index) => (
                            <Option key={index} value={item.id} >{item.asset_name}</Option>
                          ))
                        }
                      </Select>
                      {assetIds == '' && isSubmit == true ? <span className="text-danger">Please Select Asset</span> : null}
                    </div>
                  </div>
                  

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Vendor mobile number*</label>
                      <input type="text" className="form-control" disabled value={mobileNumber} />
                    </div>
                  </div>


                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Vendor email id*</label>
                      <input type="text" className="form-control" disabled value={email} />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor='exampleInput'>Contract start date*</label>
                      <DatePicker className="form-control" defaultValue={dayjs(Editdata?.contract_start_date)} format={'YYYY-MM-DD'} onChange={(date, dateString) => setState({ ...form, contractstartdate: dateString })} />
                      {form.contractstartdate == '' && isSubmit == true ? <span className="text-danger">Please Select Contract start date</span> : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor='exampleInput'>Contract end date*</label>
                      <DatePicker className="form-control" defaultValue={dayjs(Editdata?.contract_end_date)} format={'YYYY-MM-DD'} onChange={(date, dateString) => setState({ ...form, contractenddate: dateString })} />
                      {form.contractenddate == '' && isSubmit == true ? <span className="text-danger">Please Select Contract end date</span> : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor='exampleInput'>Upload document*</label>
                      <input type="file" className="form-control" onChange={(e) => setSelectedStoreFile(e.target.files[0])} accept={".pdf"}/>
                    </div>
                    {storeImage?.trim() == '' && isSubmit == true ? <span className="text-danger">Please Select  File</span> : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-right">
                <div className="m-page__button top-space">

                  <Link className="option" to='/VendorContract'>
                    <button type='button' className='btn muted-button  deca-btn-orange'  onClick={()=>dispatch(VendorList(true))}>Back</button>
                  </Link>

                  <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={() => doSubmit()}>Submit</button>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </>
  )
}

export default VendorContractMappingEdit;